import {
  type ApiResponse,
  authApi,
  type GenericErrorResponse,
} from "./authService";

interface AdminUser {
  first_name?: string;
  last_name?: string;
  email: string;
  password: string;
  agreed_to_tos: boolean;
}

interface OrganisationRegistrationData {
  admin: AdminUser;
  country_code: string;
  email_domains: string[];
  invitation_code: string;
  organisation_name: string;
}

interface OrganisationRegistrationResponse extends ApiResponse {
  admin_id: string;
  organisation_id: string;
}

export interface AdminUserResponse {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role?: 'admin' | 'super_admin';
  created_at?: string;
  last_login?: string;
}

export interface OrganisationDetailsResponse extends ApiResponse {
  id: string;
  admins: AdminUserResponse[];
  country_code: string;
  created_at: string;
  email_domains: string[];
  lab_limit: number;
  name: string;
  total_labs: number;
  total_users: number;
  subscriptions?: string[];
}

export interface WasteFactor {
  id: number;
  category: string | null;
  cost_factor: number | null;
  country: string;
  emissions_factor: number | null;
  waste_type_row: number | null;
  waste_type_row_label?: string;
  national_cost_factor?: number;
  national_emissions_factor?: number;
}

interface WasteFactorsResponse extends ApiResponse {
  national_factors: WasteFactor[];
  organisation_factors: WasteFactor[];
  lab_waste_factors: WasteFactor[];
  organisation_id: string;
}

export interface SaveWasteFactorRequest {
  category?: string;
  cost_factor?: number | null;
  emissions_factor?: number | null;
  waste_type_row?: number;
}

export interface SaveWasteFactorResponse extends ApiResponse {
  waste_factor: {
    category?: string;
    cost_factor?: number;
    emissions_factor?: number;
    id: number;
    organisation_id: string;
    waste_type_row?: number;
  };
}

export class OrganisationService {
  static async registerOrganisation(
    organisationData: OrganisationRegistrationData
  ): Promise<OrganisationRegistrationResponse> {
    const response = (await authApi("/organisations/register", {
      method: "POST",
      body: JSON.stringify(organisationData),
    })) as OrganisationRegistrationResponse | GenericErrorResponse;

    if (!response.success) {
      throw new Error(response.error);
    }

    return response;
  }

  static async getOrganisationDetails(
    organisationId: string
  ): Promise<OrganisationDetailsResponse> {
    const response = (await authApi(`/organisations/${organisationId}`)) as
      | OrganisationDetailsResponse
      | GenericErrorResponse;

    if (!response.success) {
      throw new Error(response.error);
    }

    return response;
  }

  static async getWasteFactors(): Promise<WasteFactorsResponse> {
    const response = (await authApi("/organisations/waste-factors")) as
      | WasteFactorsResponse
      | GenericErrorResponse;

    if (!response.success) {
      throw new Error(response.error);
    }

    return response;
  }

  static async saveWasteFactor(
    wasteFactorData: SaveWasteFactorRequest
  ): Promise<SaveWasteFactorResponse> {
    const response = (await authApi("/organisations/waste-factors", {
      method: "POST",
      body: JSON.stringify(wasteFactorData),
    })) as SaveWasteFactorResponse | GenericErrorResponse;

    if (!response.success) {
      throw new Error(response.error);
    }

    return response;
  }

  // static async addAdmin(adminData: AdminData): Promise<ApiResponse> {
  //   const response = await authApi("/organisations/admins", {
  //     method: "POST",
  //     body: JSON.stringify(adminData),
  //   }) as ApiResponse | GenericErrorResponse;
  //
  //   if (!response.success) {
  //     throw new Error(response.error);
  //   }
  //
  //   return response;
  // }
  //
  // static async removeAdmin(adminId: string): Promise<ApiResponse> {
  //   const response = await authApi(`/organisations/admins/${adminId}`, {
  //     method: "DELETE",
  //   }) as ApiResponse | GenericErrorResponse;
  //
  //   if (!response.success) {
  //     throw new Error(response.error);
  //   }
  //
  //   return response;
  // }
}
